import * as yup from 'yup';
import { Row, Column, EMPTY_ARRAY, RenderConfig, ASSET_TYPE, AssetUploadInput } from 'commons-ui';
import { SAMPLE_COLUMNS_NAME_LOTTERY_DETAILS, SAMPLE_COLUMNS_VALUES_LOTTERY_DETAILS } from './constants';

export const FORM_FIELD_KEYS = {
	csvFile: 'csvFile'
};

export const FORM_LAYOUT_CREATE_CONFIG = [new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.csvFile)])])];

const downloadSampleCsvFile = () => {
	const csvString = [SAMPLE_COLUMNS_NAME_LOTTERY_DETAILS, SAMPLE_COLUMNS_VALUES_LOTTERY_DETAILS].map((e) => e.join(',')).join('\n');
	const csvContent = `data:text/csv;charset=utf-8, ${csvString}`;
	const encodedUri = encodeURI(csvContent);

	const link = document.createElement('a');
	link.setAttribute('href', encodedUri);
	document.body.appendChild(link);

	return link;
};

export const FORM_FIELD_CREATE_CONFIG = {
	[FORM_FIELD_KEYS.csvFile]: new RenderConfig()
		.setName(ASSET_TYPE.CSV)
		.setLabel('Upload CSV')
		.setRenderer(AssetUploadInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			assetType: ASSET_TYPE.CSV,
			downloadFile: true,
			displayText: 'Sample CSV',
			link: downloadSampleCsvFile()
		})
};

export const validationSchema = yup.object().shape({
	message: yup
		.string()
		.test('len', 'Message should be of appropriate length!', (val) => !val || val.length > 1 || val.length < 50)
		.optional()
});
